import { Button } from "react-bootstrap";
import { DocumentListViewToolbar } from "./DocumentListViewToolbar";
import { ListViewToolbarButton } from "./ListViewToolbarButton";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { IListViewCreateDependedDocumentAction } from "../IListViewCreateDependedDocumentAction";
import { Tooltip } from "devextreme-react";

interface IProps {
  children?: React.ReactNode;
  selectedItem?: boolean | undefined;
  handleCreateDocumentActionPopupButtonClick?: () => void;
  createDocumentActions?: IListViewCreateDependedDocumentAction[];
  handleCreateDocumentAction?: any;
}

export const ListviewToolbarSubmenuButton = ({ children, selectedItem, createDocumentActions, handleCreateDocumentAction }: IProps) => {
  const { t } = useTranslation();
  const [createDocumentActionVisible, setCreateDocumentActionVisible] = useState<boolean>(false);
  const uniqueId = uuidv4();
  const handleCreateDocumentActionPopupButtonClick = () => {
    setCreateDocumentActionVisible(!createDocumentActionVisible);
  };
  return (
    <>
      {children}
      <ListViewToolbarButton
        id={`createDocumentActionsButton_${uniqueId}`}
        caption={t("CreateDocument")}
        onClick={handleCreateDocumentActionPopupButtonClick}
        iconClass={"fa-solid fa-list me-2"}
        extraClass="ms-2"
        disabled={!selectedItem}
      />
      <Tooltip
        target={`#createDocumentActionsButton_${uniqueId}`}
        position="bottom"
        visible={createDocumentActionVisible}
        onHidden={() => {
          setCreateDocumentActionVisible(false);
        }}
        hideOnOutsideClick={true}
      >
        <b>
          {createDocumentActions?.map((action, index) => (
            <div className={"text-start my-2"} key={index}>
              <Button size={"sm"} variant="" className="btn btn-light w-100" onClick={() => handleCreateDocumentAction(action)}>
                {action.title}
              </Button>
            </div>
          ))}
        </b>
      </Tooltip>
    </>
  );
};
